import { useLocation } from 'react-router-dom';
import type { ReviewKind, ReviewPageState, ReviewData } from '../pages/Accounting/ChartOfAccounts/cleanup-review/types';
import { ARCHIVE_MOCK, MERGE_MOCK, CATEGORIZE_MOCK } from '../pages/Accounting/ChartOfAccounts/cleanup-review/mockData';

interface UseCleanupReviewResult {
  state: ReviewPageState;
  data: ReviewData | null;
  count: number;
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useCleanupReview(kind: ReviewKind): UseCleanupReviewResult {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const emptyFlag = params.get('empty') === '1';
  const loadingFlag = params.get('loading') === '1';
  const errorFlag = params.get('error') === '1';

  if (loadingFlag) {
    return { state: 'loading', data: null, count: 0, loading: true, error: null, refetch: () => {} };
  }
  if (errorFlag) {
    return { state: 'error', data: null, count: 0, loading: false, error: new Error('Mock error'), refetch: () => window.location.reload() };
  }

  let data: ReviewData;
  let count: number;
  if (kind === 'archive') {
    const items = emptyFlag ? [] : ARCHIVE_MOCK;
    data = { kind: 'archive', items };
    count = items.length;
  } else if (kind === 'merge') {
    const pairs = emptyFlag ? [] : MERGE_MOCK;
    data = { kind: 'merge', pairs };
    count = pairs.length;
  } else {
    const items = emptyFlag ? [] : CATEGORIZE_MOCK;
    data = { kind: 'categorize', items };
    count = items.length;
  }

  const state: ReviewPageState = count === 0 ? 'empty' : 'populated';
  return { state, data, count, loading: false, error: null, refetch: () => {} };
}